<template>
    <div v-if="show">
        <div class="chat-group-readed-mask" @click.self="close()">
            <div class="chat-group-readed" :class="{ 'is-compact': isCompactLayout }" :style="panelStyle" @click.prevent="">
                <div class="readed-header">
                    <div class="header-title">
                        <i class="el-icon-view"></i>
                        <span>已读详情</span>
                    </div>
                    <div class="close-btn" @click="close()">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
                <div class="tabs-container">
                    <tabs :items="tabItems" :current="currentTab" @change="onTabChange"></tabs>
                    <div class="tab-content">
                        <div v-show="currentTab === 0" class="member-list">
                            <empty-state
                                v-if="readedMembers.length === 0"
                                class="empty-state"
                                icon="el-icon-check"
                                title="暂无已读"
                                compact
                            ></empty-state>
                            <virtual-scroller v-else class="scroll-box" :items="readedMembers" :item-height="memberItemHeight">
                                <template v-slot="{ item }">
                                    <group-member-bar :member="item" :group="group" :height="memberItemHeight"></group-member-bar>
                                </template>
                            </virtual-scroller>
                        </div>
                        <div v-show="currentTab === 1" class="member-list">
                            <empty-state
                                v-if="unreadMembers.length === 0"
                                class="empty-state"
                                icon="el-icon-warning"
                                title="全部已读"
                                compact
                            ></empty-state>
                            <virtual-scroller v-else class="scroll-box" :items="unreadMembers" :item-height="memberItemHeight">
                                <template v-slot="{ item }">
                                    <group-member-bar :group="group" :member="item" :height="memberItemHeight"></group-member-bar>
                                </template>
                            </virtual-scroller>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
import VirtualScroller from '../common/VirtualScroller.vue';
import GroupMemberBar from '../group/GroupMemberBar.vue';
import Tabs from '../common/Tabs.vue';

export default {
    name: "chatGroupReaded",
    components: {
        VirtualScroller,
        GroupMemberBar,
        Tabs
    },
    data() {
        return {
            show: false,
            pos: {
                x: 0,
                y: 0,
                width: 296,
                maxHeight: 360
            },
            anchorRect: null,
            isCompactLayout: false,
            readedMembers: [],
            unreadMembers: [],
            currentTab: 0
        }
    },
    props: {
        group: {
            type: Object
        },
        groupMembers: {
            type: Array
        },
        msgInfo: {
            type: Object
        }
    },
    computed: {
        tabItems() {
            return [`已读 ${this.readedMembers.length}`, `未读 ${this.unreadMembers.length}`];
        },
        panelStyle() {
            return {
                left: `${this.pos.x}px`,
                top: `${this.pos.y}px`,
                width: `${this.pos.width}px`,
                maxHeight: `${this.pos.maxHeight}px`
            };
        },
        memberItemHeight() {
            return this.isCompactLayout ? 42 : 44;
        }
    },
    mounted() {
        window.addEventListener('resize', this.onViewportChange);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onViewportChange);
    },
    methods: {
        close() {
            this.show = false;
            this.anchorRect = null;
        },
        onTabChange(index) {
            this.currentTab = index;
        },
        open(rect) {
            this.show = true;
            this.currentTab = 0;
            this.anchorRect = rect;
            this.updatePosition(rect);
            this.loadReadedUser()
        },
        onViewportChange() {
            if (!this.show || !this.anchorRect) {
                return;
            }
            this.updatePosition(this.anchorRect);
        },
        updatePosition(rect) {
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const gap = 12;
            const compactLayout = viewportWidth <= 720;
            const panelWidth = compactLayout ? Math.min(304, viewportWidth - gap * 2) : 276;
            const panelMaxHeight = Math.min(compactLayout ? 336 : 344, viewportHeight - gap * 2);
            let x = compactLayout
                ? Math.max(gap, Math.round((viewportWidth - panelWidth) / 2))
                : (this.msgInfo.selfSend ? rect.left - panelWidth - 12 : rect.right + 12);
            let y = compactLayout
                ? viewportHeight - panelMaxHeight - gap
                : rect.top + rect.height / 2 - panelMaxHeight / 2;

            x = Math.min(Math.max(gap, x), viewportWidth - panelWidth - gap);
            y = Math.min(Math.max(gap, y), viewportHeight - panelMaxHeight - gap);

            this.isCompactLayout = compactLayout;
            this.pos.x = Math.round(x);
            this.pos.y = Math.round(y);
            this.pos.width = panelWidth;
            this.pos.maxHeight = panelMaxHeight;
        },
        loadReadedUser() {
            this.readedMembers = [];
            this.unreadMembers = [];
            this.$http({
                url: "/message/group/findReadedUsers",
                method: 'get',
                params: { groupId: this.msgInfo.groupId, messageId: this.msgInfo.id }
            }).then(userIds => {
                const readedUserIdSet = new Set((Array.isArray(userIds) ? userIds : []).map((userId) => String(userId)));
                const readedMembers = [];
                const unreadMembers = [];
                (this.groupMembers || []).forEach(member => {
                    // 发送者和已退群的不显示
                    if (member.userId == this.msgInfo.sendId || member.quit) {
                        return;
                    }
                    // 区分已读还是未读
                    if (readedUserIdSet.has(String(member.userId))) {
                        readedMembers.push(member);
                    } else {
                        unreadMembers.push(member);
                    }
                });
                this.readedMembers = readedMembers;
                this.unreadMembers = unreadMembers;
                // 更新已读人数
                let msgInfo = {
                    id: this.msgInfo.id,
                    groupId: this.msgInfo.groupId,
                    readedCount: readedMembers.length
                }
                let chatInfo = {
                    type: 'GROUP',
                    targetId: this.msgInfo.groupId
                }
                this.chatStore.updateMessage(msgInfo, chatInfo)
            })
        }
    }
}
</script>

<style lang="scss">
.chat-group-readed-mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
}

.chat-group-readed {
    position: fixed;
    border-radius: 14px;
    overflow: hidden;
    background: var(--im-surface-panel-strong);
    backdrop-filter: blur(20px);
    box-shadow: 0 20px 40px -28px rgba(var(--im-black-rgb), 0.45);
    border: 1px solid var(--im-surface-panel-border);
    animation: slideIn 0.22s ease-out;
    display: flex;
    flex-direction: column;

    .readed-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 12px 8px;
        background: var(--im-surface-panel);
        border-bottom: 1px solid var(--im-surface-panel-border);

        .header-title {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 13px;
            font-weight: 600;
            color: var(--im-text-color-primary);

            i {
                color: var(--im-color-primary);
                font-size: 14px;
            }
        }

        .close-btn {
            width: 22px;
            height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s ease;
            color: var(--im-text-color-light);

            &:hover {
                background: rgba(var(--im-black-rgb), 0.08);
                color: var(--im-text-color-primary);
            }

            i {
                font-size: 13px;
            }
        }
    }

    .tabs-container {
        display: flex;
        flex: 1;
        flex-direction: column;
        min-height: 0;
        padding: 8px 8px 6px;

        .tabs {
            height: 34px;
            padding: 3px;
            border-radius: 10px;
            background: rgba(var(--im-black-rgb), 0.05);
        }

        .tabs .tab {
            padding: 6px 10px;
            border-radius: 8px;
            font-size: 12px;
            font-weight: 600;
        }

        .tabs .tab.active {
            transform: none;
            box-shadow: none;
            background: var(--im-surface-panel-strong);
        }

        .tabs .tab.active::after {
            display: none;
        }

        .tab-content {
            flex: 1;
            min-height: 0;
            padding: 8px 0 0;
            background: transparent;

            .member-list {
                position: relative;
                min-height: 0;
                height: 100%;
                border-radius: 12px;
                background: var(--im-surface-panel-soft);
                border: 1px solid var(--im-surface-panel-border);
                overflow: hidden;

                .empty-state {
                    min-height: 128px;
                }

                .scroll-box {
                    height: 100%;
                    padding: 4px;
                }
            }
        }
    }

    .group-member-bar {
        padding: 0 10px;
        margin: 0;
        border-radius: 10px;

        .name {
            padding: 0 0 0 8px;
        }

        .name .name-text {
            font-size: 13px;
        }

        ::v-deep .el-tag {
            height: 18px;
            line-height: 16px;
            padding: 0 5px;
            font-size: 10px;
            border-radius: 999px;
        }
    }

    &.is-compact {
        border-radius: 18px 18px 12px 12px;
    }
}

// 弹窗进入动画
@keyframes slideIn {
    0% {
        opacity: 0;
        transform: scale(0.9) translateY(-10px);
    }
    100% {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}
</style>
